import { normalizeLovBatchResponse } from './normalize'

import type { LovBatchFetchFn } from './types'

/** 用项目 HttpRequest 等封装批量 LOV 请求 */
export function createLovBatchFetcher(
  request: (types: string[]) => Promise<unknown>
): LovBatchFetchFn {
  return async (types) => {
    if (!types.length) {
      return {}
    }
    const data = await request(types)
    return normalizeLovBatchResponse(data)
  }
}
